<template>
    <div>
        <div class="rentShop_add">
            <div class="owner_information_one">
                <h3>
                    <i></i>楼盘信息
                </h3>
                <div class="owner_info_list">
                    <ul class="owner_info_list_one">
                        <li>
                            <div class="title">
                                <span class="ok">*</span>房源地址：
                            </div>
                            <el-autocomplete popper-class="my-autocomplete" v-model="buildInfo.residentialAreaName"
                                :fetch-suggestions="querySearchAsync" placeholder="请输入小区" @select="handleSelect">
                                <template slot-scope="{ item }">
                                    <div class="name" @select="handleSelect">{{ item.name }}</div>
                                </template>
                            </el-autocomplete>
                        </li>
                        <li>
                            <el-select v-model="buildInfo.dicTungId" placeholder="栋座" @visible-change="getHouseInfoList"
                                @change="getfloorDetails">
                                <el-option v-for="(item, index) in houseInfoList" :key="index" :label="item.tungNumber"
                                    :value="item.tungId"></el-option>
                            </el-select>
                            <el-select v-model="buildInfo.dicUnitId" placeholder="单元" @visible-change="getUnitInfoList"
                                @change="changeUnit">
                                <el-option v-for="(item, index) in unitInfoList" :key="index" :label="item.unitNumber"
                                    :value="item.unitId"></el-option>
                            </el-select>
                            <el-select v-model="buildInfo.dicFloorId" placeholder="楼层" @change="changefloor">
                                <el-option v-for="(item, index) in floorNumData" :key="index" :label="item.floorName"
                                    :value="item.floorId" @click="getRoomNum(index)"></el-option>
                            </el-select>
                            <el-select v-model="buildInfo.dicRoomId" @change="searchHousetype" placeholder="房号">
                                <el-option v-for="(item, index) in roomNumData" :key="index" :label="item.roomName"
                                    :value="item.roomId"></el-option>
                            </el-select>
                        </li>
                        <li>
                            <div class="title">
                                <span class="ok">*</span>出租面积：
                            </div>
                            <el-input v-model="buildInfo.rentalArea" placeholder="请输入"></el-input>
                            <span class="lastUnits">㎡</span>
                        </li>
                        <li>
                            <div class="title">
<!--                                <span class="ok">*</span>-->
                              朝
                                <span style="visibility:hidden;">占位</span>向：
                            </div>
                            <el-select v-model="buildInfo.orientation" placeholder="请选择" @visible-change="getbuildlist">
                                <el-option v-for="(item, index) in towardIdList" :key="index" :label="item.valueDesc"
                                    :value="item.value"></el-option>
                            </el-select>
                        </li>
                        <li>
                            <div class="title">
                                <span class="ok">*</span>装修程度：
                            </div>
                            <el-select v-model="buildInfo.decorationDegree" placeholder="请选择"
                                @visible-change="getDecorationDegree">
                                <el-option v-for="(item, index) in decorDegreeList" :key="index" :label="item.valueDesc"
                                    :value="item.value"></el-option>
                            </el-select>
                        </li>
                    </ul>
                </div>
                <div class="owner_info_list">
                    <ul class="owner_info_list_one">
                        <li>
                            <div class="title">
                                <span class="ok">*</span>建筑类型：
                            </div>
                            <el-select v-model="buildInfo.architecturalType" placeholder="请选择"
                                @visible-change="getBuildingType">
                                <el-option v-for="(item, index) in buildTypeData" :key="index" :label="item.valueDesc"
                                    :value="item.value"></el-option>
                            </el-select>
                        </li>
                        <li>
                            <div class="title">
                                <span>
                                    <span>所属楼层：</span>
                                </span>
                            </div>
                            <el-input placeholder="所属楼层" v-model="buildInfo.belongFloor"></el-input>
                        </li>
                        <li>
                            <div class="title">
                                <span>
                                    <span>产证号：</span>
                                </span>
                            </div>
                            <el-input placeholder="请输入" v-model="buildInfo.estateCertificationNo"></el-input>
                        </li>
                        <li>
                            <div class="title">
                                <span>
                                    <span class="ok">*</span>产
                                    <span style="visibility:hidden;">占位</span>权：
                                </span>
                            </div>
                            <el-select v-model="buildInfo.propertyRight" placeholder="请选择" @visible-change="getProperty">
                                <el-option v-for="(item, index) in propertyList" :key="index" :label="item.valueDesc"
                                    :value="item.value"></el-option>
                            </el-select>
                        </li>
                        <li>
                            <div class="title">
                                <span>
                                    <span class="ok">*</span>
                                    <span>房源类型：</span>
                                </span>
                            </div>
                            <el-select v-model="buildInfo.houseLevel" placeholder="请选择" @visible-change="getHouseLevel">
                                <el-option v-for="(item, index) in houseLevelList" :key="index" :label="item.valueDesc"
                                    :value="item.value"></el-option>
                            </el-select>
                        </li>
                        <li>
                            <div class="title">
                                <span>
                                    <span class="ok">*</span>来
                                    <span style="visibility:hidden;">占位</span>源：
                                </span>
                            </div>
                            <el-select v-model="buildInfo.source" placeholder="请选择" @visible-change="getSourceList">
                                <el-option v-for="(item, index) in sourceList" :key="index" :label="item.valueDesc"
                                    :value="item.value"></el-option>
                            </el-select>
                        </li>
                    </ul>
                </div>
                <div class="owner_info_list">
                    <ul class="owner_info_list_one">
                        <li>
                            <div class="title">
                                <span>是否凶宅</span>

                            </div>
                            <el-select v-model="buildInfo.unluckyAbode" placeholder="请选择"
                                @visible-change="getUnluckyAbodeList">
                                <el-option v-for="(item, index) in unluckyAbodeList" :key="index" :label="item.valueDesc"
                                    :value="item.value"></el-option>
                            </el-select>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="owner_information_two">
                <h3>
                    <i></i>业务信息
                </h3>
                <div class="owner_info_list">
                    <ul class="owner_info_list_one">
                        <li>
                            <div class="title">
                                <span><span class="ok">*</span>经营行业：</span>
                            </div>
                            <el-select v-model="buildInfo.businessSector" placeholder="请选择"
                                @visible-change="getBusinessSector">
                                <el-option v-for="(item, index) in businessSectorList" :key="index" :label="item.valueDesc"
                                    :value="item.value"></el-option>
                            </el-select>
                        </li>
                        <li>
                            <div class="title">
                                <span>适用于行业：</span>
                            </div>
                            <el-select v-model="buildInfo.applicableToIndustry" multiple collapse-tags placeholder="请选择"
                                @visible-change="getApplicableToIndustry">
                                <el-option v-for="(item, index) in applicableToIndustryList" :key="index"
                                    :label="item.valueDesc" :value="item.value"></el-option>
                            </el-select>
                        </li>
                        <li>
                            <div class="title">
                                <span><span class="ok">*</span>经营状态：</span>
                            </div>
                            <el-select v-model="buildInfo.businessStatus" placeholder="请选择"
                                @visible-change="getBusinessStatus">
                                <el-option v-for="(item, index) in businessStatusList" :key="index" :label="item.valueDesc"
                                    :value="item.value"></el-option>
                            </el-select>
                        </li>
                        <li>
                            <div class="title">
                                <span class="ok">*</span>出租方式：
                            </div>
                            <el-select v-model="buildInfo.rentalMode" placeholder="请选择">
                                <el-option v-for="(item, index) in rentalModeList" :key="index" :label="item.valueDesc"
                                    :value="item.value"></el-option>
                            </el-select>
                        </li>
                        <li>
                            <div class="title">
                                <span>剩余租期：</span>
                            </div>
                            <el-input v-model="buildInfo.remainingLeaseTerm" placeholder="请输入"></el-input>
                        </li>
                        <li
                            v-if="buildInfo.rentalMode == 'SUBLEASE_WHOLE_RENT' || buildInfo.rentalMode == 'SUBLEASE_AND_JOINT_TENANCY'">
                            <div class="title">
                                <span>转让费：</span>
                            </div>
                            <el-input v-model="buildInfo.transferFee" placeholder="请输入"></el-input>
                            <span class="lastUnits">元</span>
                        </li>
                        <li v-else></li>
                    </ul>
                </div>
                <div class="owner_info_list">
                    <ul class="owner_info_list_one">
                        <li>
                            <div class="title">
                                <span>免租期：</span>
                            </div>
                            <el-input v-model="buildInfo.rentFreePeriod" v-on:input="getUnitPrice"
                                placeholder="请输入"></el-input>
                            <el-select v-model="buildInfo.rentFreePeriodUnit" placeholder="请选择"
                                @visible-change="getRentFreePeriodUnit">
                                <el-option v-for="(item, index) in rentFreePeriodUnitList" :key="index"
                                    :label="item.valueDesc" :value="item.value"></el-option>
                            </el-select>
                        </li>
                        <li>
                            <div class="title">
                                <span class="ok">*</span>租<span style="visibility:hidden;">占位</span>金：
                            </div>
                            <el-input v-model="buildInfo.rent" v-on:input="getUnitPrice" placeholder="请输入"></el-input>
                            <el-select v-model="buildInfo.rentCompany" placeholder="请选择">
                                <el-option v-for="(item, index) in rentTungList" :key="index" :label="item.valueDesc"
                                    :value="item.value"></el-option>
                            </el-select>
                        </li>
                        <li>
                            <div class="title">
                                <span class="ok">*</span>付款方式：
                            </div>
                            <el-select v-model="buildInfo.paymentMethod" placeholder="请选择" @visible-change="getPayWayList">
                                <el-option v-for="(item, index) in payWayList" :key="index" :label="item.valueDesc"
                                    :value="item.value"></el-option>
                            </el-select>
                        </li>
                        <li>
                            <div class="title">
                                <span>租房押金：</span>
                            </div>
                            <el-input v-model="buildInfo.deposit" placeholder="请输入"></el-input>
                        </li>
                        <li>
                            <div class="title">
                                <span>
                                    底
                                    <span style="visibility:hidden;">占位</span>价 ：
                                </span>
                            </div>
                            <el-input v-model="buildInfo.floorPrice" placeholder="请输入"></el-input>
                        </li>
                        <li>
                            <div class="title">
                                <span class="ok">*</span>性
                                <span style="visibility:hidden;">占位</span>质：
                            </div>
                            <el-select v-model="buildInfo.property" placeholder="请选择" @visible-change="getPropRightNature">
                                <el-option v-for="(item, index) in natureList" :key="index" :label="item.valueDesc"
                                    :value="item.value"></el-option>
                            </el-select>
                        </li>

                    </ul>
                </div>
                <div class="owner_info_list">
                    <ul class="owner_info_list_one">
                        <li>
                            <div class="title">
                                <span>最短租期：</span>
                            </div>
                            <el-select v-model="buildInfo.minimumTenancy" placeholder="请选择">
                                <el-option v-for="(item, index) in minimumTenancyList" :key="index" :label="item.valueDesc"
                                    :value="item.value"></el-option>
                            </el-select>
                        </li>
                        <li>
                            <div class="title">
                                <span>看房方式：</span>
                            </div>
                            <el-select v-model="buildInfo.houseInspectionMethod" placeholder="请选择"
                                @visible-change="getSeeHouseMode">
                                <el-option v-for="(item, index) in seeHouseModeList" :key="index" :label="item.valueDesc"
                                    :value="item.value"></el-option>
                            </el-select>
                        </li>
                        <li>
                            <div class="title">
                                <span>委托方式：</span>
                            </div>
                            <el-select v-model="buildInfo.exclusiveOrNot" placeholder="请选择"
                                @visible-change="getSeeHouseMode">
                                <el-option v-for="(item, index) in exclusiveOrNotList" :key="index" :label="item.valueDesc"
                                    :value="item.value"></el-option>
                            </el-select>
                            </li>
                            <li>
                            <div class="title" style="margin-left:4%;">
                                <span>委托日期：</span>
                            </div>
                            <el-date-picker v-model="allDate" type="daterange" range-separator="至" start-placeholder="开始日期"
                                end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>

                        </li>
                        <li></li>
                    </ul>
                </div>
                <div class="owner_info_list">
                    <ul class="owner_info_list_one">
                        <li>
                            <div class="title">
                                <span>规<span style="visibility:hidden;">占位</span>格：</span>
                            </div>
                            <el-input v-model="buildInfo.specifications"></el-input>
                        </li>
                        <li>
                            <div class="title">
                                <span>相关费用：</span>
                            </div>
                            <el-input v-model="buildInfo.relatedExpenses"></el-input>
                        </li>
                        <li>
                            <div class="title">
                                <span>客流人群：</span>
                            </div>
                            <el-input v-model="buildInfo.passengerFlowCrowd"></el-input>
                        </li>
                    </ul>
                </div>
                <div class="owner_info_list">
                    <ul class="owner_info_list_one">
                        <li>
                            <div class="title">
                                <span style="color:#5E75E6;">费用明细</span>（多选）：
                            </div>
                            <el-select v-model="buildInfo.expenseDetail" multiple style="margin-left: 20px;"
                                placeholder="请选择">
                                <el-option v-for="(item, index) in expenseDetailList" :key="index" :label="item.valueDesc"
                                    :value="item.value"></el-option>
                            </el-select>
                        </li>
                        <li>
                            <div class="title">
                                <span class="ok">*</span>
                                <span style="color:#5E75E6;">特性</span>（多选）：
                            </div>
                            <el-select v-model="buildInfo.features" multiple style="margin-left: 20px;" placeholder="请选择">
                                <el-option v-for="(item, index) in featuresList" :key="index" :label="item.valueDesc"
                                    :value="item.value"></el-option>
                            </el-select>
                        </li>
                        <li>
                            <div class="title">
                                <span class="ok">*</span>
                                <span style="color:#5E75E6;">配套设施</span>（多选）：
                            </div>
                            <el-select v-model="buildInfo.supportingFacilities" multiple style="margin-left: 20px;"
                                placeholder="请选择">
                                <el-option v-for="(item, index) in supportingFacilitiesList" :key="index"
                                    :label="item.valueDesc" :value="item.value"></el-option>
                            </el-select>
                        </li>
                    </ul>
                </div>
                <div class="owner_info_list">
                    <ul class="owner_info_list_one">
                        <li>
                            <div class="title">
                                <span>公开备注:</span>
                            </div>
                            <el-input type="textarea" resize="none" placeholder="请输入公开备注" autosize
                                v-model="buildInfo.publicRemarks"></el-input>
                        </li>
                        <li>
                            <div class="title">
                                <span>保密备注:</span>
                            </div>
                            <el-input type="textarea" resize="none" placeholder="请输入保密备注" autosize
                                v-model="buildInfo.privateRemarks"></el-input>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="owner_information_three"
                v-if="buildInfo.rentalMode == 'SUBLEASE_WHOLE_RENT' || buildInfo.rentalMode == 'SUBLEASE_AND_JOINT_TENANCY'">
                <h3>
                    <i></i>转租者信息
                </h3>
                <div class="owner_info_list">
                    <ul class="owner_info_list_one">
                        <li>
                            <span>转租者</span>
                        </li>
                        <li>
                            <div class="text">
                                <div class="text_item">
                                    <div class="title">
                                        姓
                                        <span style="visibility:hidden;">占</span>名：
                                    </div>
                                    <el-input v-model="buildInfo.name" placeholder="请输入姓名"></el-input>
                                </div>
                                <div class="text_item">
                                    <div class="title">
                                        性
                                        <span style="visibility:hidden;">占</span>别：
                                    </div>
                                    <el-select v-model="buildInfo.sex" placeholder="请选择" @visible-change="getSexList">
                                        <el-option v-for="(item, index) in sexList" :key="index" :label="item.valueDesc"
                                            :value="item.value"></el-option>
                                    </el-select>
                                </div>
                                <div class="text_item">
                                    <div class="title">
                                        婚
                                        <span style="visibility:hidden;">占位</span>姻：
                                    </div>
                                    <el-select v-model="buildInfo.marriage" placeholder="请选择"
                                        @visible-change="getMaritalStatus">
                                        <el-option v-for="(item, index) in maritalStatusList" :key="index"
                                            :label="item.valueDesc" :value="item.value"></el-option>
                                    </el-select>
                                </div>
                                <div class="text_item">
                                    <div class="title">
                                        <span>证件号：</span>
                                    </div>
                                    <el-select v-model="buildInfo.idType" placeholder="请选择"
                                        @visible-change="getCertificatesType"
                                        @change="setTestIdnumber('', buildInfo.idNumber, 1)">
                                        <el-option v-for="(item, index) in certificatesTypeList" :key="index"
                                            :label="item.valueDesc" :value="item.value"></el-option>
                                    </el-select>
                                    <el-input v-model="buildInfo.idNumber"
                                        @change="setTestIdnumber('', buildInfo.idNumber, 1)" placeholder="请输入证件号"></el-input>
                                </div>
                            </div>
                            <div class="text">
                                <div class="text_item">
                                    <div class="title">
                                        <span class="ok">*</span>电
                                        <span style="visibility:hidden;">占位</span> 话：
                                    </div>
                                    <div class="input_in_text">
                                        <span class="addPhone" :key="index" v-for="(item, index) in buildInfo.phone">
                                            <el-input style="margin-right: 20px;" placeholder="请输入电话"
                                                v-model="buildInfo.phone[index]" class="input-iphone"
                                                @change="setTestphone(index, '', buildInfo.phone[index], 1)"></el-input>
                                            <i :class="index === 0 ? 'el-icon-plus' : 'el-icon-close'"
                                                @click="deletePhone(index)"
                                                style="color: #ffffff;background: #5E75E6;border-radius: 50%;min-width: 15px;height: 15px;text-align: center;line-height: 15px;font-size: 12px"></i>
                                        </span>
                                    </div>
                                </div>
                                <div class="text_item">
                                    <div class="title">
                                        地
                                        <span style="visibility:hidden;">占位</span> 址：
                                    </div>
                                    <el-input v-model="buildInfo.address" placeholder="请输入地址"></el-input>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="owner_information_three" v-else>
                <h3>
                    <i></i>业主信息
                </h3>
                <div class="owner_info_list">
                    <ul class="owner_info_list_one">
                        <li>
                            <span>业主</span>
                        </li>
                        <li>
                            <div class="text">
                                <div class="text_item">
                                    <div class="title">
                                        姓
                                        <span style="visibility:hidden;">占</span>名：
                                    </div>
                                    <el-input v-model="buildInfo.name" placeholder="请输入姓名"></el-input>
                                </div>
                                <div class="text_item">
                                    <div class="title">
                                        性
                                        <span style="visibility:hidden;">占</span>别：
                                    </div>
                                    <el-select v-model="buildInfo.sex" placeholder="请选择" @visible-change="getSexList">
                                        <el-option v-for="(item, index) in sexList" :key="index" :label="item.valueDesc"
                                            :value="item.value"></el-option>
                                    </el-select>
                                </div>
                                <div class="text_item">
                                    <div class="title">
                                        婚
                                        <span style="visibility:hidden;">占位</span>姻：
                                    </div>
                                    <el-select v-model="buildInfo.marriage" placeholder="请选择"
                                        @visible-change="getMaritalStatus">
                                        <el-option v-for="(item, index) in maritalStatusList" :key="index"
                                            :label="item.valueDesc" :value="item.value"></el-option>
                                    </el-select>
                                </div>
                                <div class="text_item">
                                    <div class="title">
                                        <span>证件号：</span>
                                    </div>
                                    <el-select v-model="buildInfo.idType" placeholder="请选择"
                                        @visible-change="getCertificatesType"
                                        @change="setTestIdnumber('', buildInfo.idNumber, 1)">
                                        <el-option v-for="(item, index) in certificatesTypeList" :key="index"
                                            :label="item.valueDesc" :value="item.value"></el-option>
                                    </el-select>
                                    <el-input v-model="buildInfo.idNumber"
                                        @change="setTestIdnumber('', buildInfo.idNumber, 1)" placeholder="请输入证件号"></el-input>
                                </div>
                            </div>
                            <div class="text">
                                <div class="text_item">
                                    <div class="title">
                                        <span class="ok">*</span>电
                                        <span style="visibility:hidden;">占位</span> 话：
                                    </div>
                                    <div class="input_in_text">
                                        <span class="addPhone" :key="index" v-for="(item, index) in buildInfo.phone">
                                            <el-input style="margin-right: 20px;" placeholder="请输入电话"
                                                v-model="buildInfo.phone[index]" class="input-iphone"
                                                @change="setTestphone(index, '', buildInfo.phone[index], 1)"></el-input>
                                            <i :class="index === 0 ? 'el-icon-plus' : 'el-icon-close'"
                                                @click="deletePhone(index)"
                                                style="color: #ffffff;background: #5E75E6;border-radius: 50%;min-width: 15px;height: 15px;text-align: center;line-height: 15px;font-size: 12px"></i>
                                        </span>
                                    </div>
                                </div>
                                <div class="text_item">
                                    <div class="title">
                                        地
                                        <span style="visibility:hidden;">占位</span> 址：
                                    </div>
                                    <el-input v-model="buildInfo.address" placeholder="请输入地址"></el-input>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="owner_info_list" v-for="(item, index) in buildInfo.partOwnerInfo" :key="index">
                    <ul class="owner_info_list_one">
                        <li>
                            <span>共有人</span>
                            <img v-if="index == 0" src="../../../assets/icon-add.png" alt="添加" @click="addMen(index)" />
                            <img v-else src="../../../assets/icon-delete.png" alt="删除" @click="addMen(index)" />
                        </li>
                        <li>
                            <div class="text">
                                <div class="text_item">
                                    <div class="title">
                                        姓
                                        <span style="visibility:hidden;">占</span>名：
                                    </div>
                                    <el-input v-model="item.name" placeholder="请输入姓名"></el-input>
                                </div>
                                <div class="text_item">
                                    <div class="title">
                                        性
                                        <span style="visibility:hidden;">占</span>别：
                                    </div>
                                    <el-select v-model="item.sex" placeholder="请选择" @visible-change="getSexList">
                                        <el-option v-for="(sexItem, sexIndex) in sexList" :key="sexIndex"
                                            :label="sexItem.valueDesc" :value="sexItem.value"></el-option>
                                    </el-select>
                                </div>
                                <div class="text_item">
                                    <div class="title">
                                        婚
                                        <span style="visibility:hidden;">占位</span>姻：
                                    </div>
                                    <el-select v-model="item.marriage" placeholder="请输入" @visible-change="getMaritalStatus">
                                        <el-option v-for="(marriageItem, marriageIndex) in maritalStatusList"
                                            :key="marriageIndex" :label="marriageItem.valueDesc"
                                            :value="marriageItem.value"></el-option>
                                    </el-select>
                                </div>
                                <div class="text_item">
                                    <div class="title">
                                        <span>证件号：</span>
                                    </div>
                                    <el-select v-model="item.idType" placeholder="请选择" @visible-change="getCertificatesType"
                                        @change="setTestIdnumber(index, item.idNumber, 2)">
                                        <el-option v-for="(typeItem, typeIndex) in certificatesTypeList" :key="typeIndex"
                                            :label="typeItem.valueDesc" :value="typeItem.value"></el-option>
                                    </el-select>
                                    <el-input v-model="item.idNumber" @change="setTestIdnumber(index, item.idNumber, 2)"
                                        placeholder="请输入证件号"></el-input>
                                </div>
                            </div>
                            <div class="text">
                                <div class="text_item">
                                    <div class="title">
                                        电
                                        <span style="visibility:hidden;">占位</span> 话：
                                    </div>
                                    <div class="input_in_text">
                                        <span class="addPhone" :key="phoneIndex"
                                            v-for="(phoneVal, phoneIndex) in item.phone">
                                            <el-input style="margin-right: 20px;" placeholder="请输入电话"
                                                v-model="item.phone[phoneIndex]" class="input-iphone"
                                                @change="setTestphone(index, phoneIndex, item.phone[phoneIndex], 2)"></el-input>
                                            <i :class="phoneIndex === 0 ? 'el-icon-plus' : 'el-icon-close'"
                                                @click="deletePhone1(index, phoneIndex)"
                                                style="color: #ffffff;background: #5E75E6;border-radius: 50%;min-width: 15px;height: 15px;text-align: center;line-height: 15px;font-size: 12px"></i>
                                        </span>
                                    </div>
                                </div>
                                <div class="text_item">
                                    <div class="title">
                                        地
                                        <span style="visibility:hidden;">占位</span> 址：
                                    </div>
                                    <el-input v-model="item.address" placeholder="请输入地址"></el-input>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="owner_information_four">
                <h3>
                    <i></i>发布信息
                </h3>
                <div class="owner_info_list">
                    <ul class="owner_info_list_one">
                        <li>
                            <div class="title">标题：</div>
                            <el-input v-model="buildInfo.title"></el-input>
                            <div style="margin-left:20px;width:280px;">
                                <el-checkbox v-model="buildInfo.publishLocation">是否发布</el-checkbox>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="owner_info_list">
                    <ul class="owner_info_list_one">
                        <!-- <li>
              <div class="title">
                <span>房屋优势:</span>
              </div>
              <el-input type="textarea" v-model="buildInfo.housingAdvantage" resize="none" placeholder="请输入核心卖点"></el-input>
            </li>-->
                        <li>
                            <div class="title">
                                <span>描述:</span>
                            </div>
                            <el-input type="textarea" v-model="buildInfo.decorationDescription" resize="none"
                                placeholder="请输入描述"></el-input>
                        </li>
                    </ul>
                </div>
                <!-- <div class="owner_info_list">
          <ul class="owner_info_list_one">
            <li>
              <div class="title">
                <span>户型介绍:</span>
              </div>
              <el-input type="textarea" v-model="buildInfo.houseTypeDes" resize="none" placeholder="请输入户型介绍"></el-input>
            </li>
            <li>
              <div class="title">
                <span>费税解析:</span>
              </div>
              <el-input type="textarea" v-model="buildInfo.analysisTaxation" resize="none" placeholder="请输入费税解析"></el-input>
            </li>
          </ul>
        </div>-->
            </div>
            <div class="owner_information_five" v-if="permisShow('图片上传')">
                <h3>
                    <i></i>图片及视频
                    <span style="font-size:12px;color:red;">（注意：照片请使用真实照片，格式支持jpeg、png等）</span>
                </h3>
                <div class="owner_info_list">
                    <ul class="owner_info_list_one">
                        <li class="message_wrap_pic">
                            <div class="upload_img">
                                <span class="upload_img_title">室内图片</span>
                                <ul class="upload_img_type">
                                    <li class="upload_img_icon" v-for="(item, index) in buildInfo.indoorPicture"
                                        :key="index">
                                        <img :src="item.url" alt />
                                    </li>
                                    <li class="upload_img_icon" @click="showPicturList('indoorPicture')">
                                        <i class="iconfont icon-icon_shinei"></i>
                                        <span>室内图片</span>
                                    </li>
                                </ul>
                            </div>
                            <div class="upload_img">
                                <span class="upload_img_title">户型图片</span>
                                <ul class="upload_img_type">
                                    <li class="upload_img_icon" v-for="(item, index) in buildInfo.apartmentPicture"
                                        :key="index">
                                        <img :src="item.url" alt />
                                    </li>
                                    <li class="upload_img_icon" @click="showPicturList('apartmentPicture')">
                                        <i class="iconfont icon-icon_huxing"></i>
                                        <span>户型图片</span>
                                    </li>
                                </ul>
                            </div>
                            <div class="upload_img">
                                <span class="upload_img_title">VR视频</span>
                                <ul class="upload_img_type">
                                    <li class="upload_img_icon" v-for="(item, index) in buildInfo.vrVideo" :key="index">
                                        <img :src="item.url" alt />
                                    </li>
                                    <li class="upload_img_icon" @click="showPicturList('vrVideo')">
                                        <i class="iconfont icon-icon_VR"></i>
                                        <span>上传VR视频</span>
                                    </li>
                                </ul>
                            </div>
                            <div class="upload_img">
                                <span class="upload_img_title">保密图片</span>
                                <ul class="upload_img_type">
                                    <li class="upload_img_icon" v-for="(item, index) in buildInfo.secretPicture"
                                        :key="index">
                                        <img :src="item.url" alt />
                                    </li>
                                    <li class="upload_img_icon" @click="showPicturList('secretPicture')">
                                        <i class="iconfont icon_baomi"></i>
                                        <span>保密图片</span>
                                    </li>
                                </ul>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="footer_btn_wrap" v-if="btnSave">
                <el-button class="remove_btn" @click="removeSaveBtn">取消</el-button>
                <el-button v-points @click="addHouse('add')">保存</el-button>
                <el-button v-points class="save_btn" @click="addHouse('save')">保存并提交</el-button>
            </div>
            <div class="footer_btn_wrap" v-else>
                <el-button class="remove_btn" @click="removeSaveBtn">取消</el-button>
                <el-button v-points @click="addHouse">保存</el-button>
            </div>>
        </div>
        <el-dialog v-if="uploadImgVisible" title="上传图片" :visible.sync="uploadImgVisible" @close="closeBtn">
            <UploadImg v-if="uploadImgVisible" :isindoorPicture="isindoor" @cancelUpload="uploadImgVisible = false"
                @saveUpload="upLoadingBtn"></UploadImg>
        </el-dialog>
    </div>
</template>
<script type="text/javascript">
/* eslint-disable */
import AddKeyAlert from "@/components/common/addKeyAlert";
import UploadImg from "@/components/common/uploadImg";
import { dicGet } from "@/api";
import {
    communitynameQuery,
    communityDetail,
    tungQuery,
    tungunitQuery,
    storeFind,
    queryByPhoneOrCard
} from "@/api/manageCenter.js";
import {
    houseAdd,
    houseTypeQuery,
    houseTypeFind,
    checkHousing,
    queryApprovalWhetherOpen
} from "@/api/houseManage";
import { customerLevel } from "@/api/customeManage";
import { mapGetters } from 'vuex'
export default {
    // name: "新增出租",
    name: "/addRentShop",
    computed: {
        ...mapGetters({
            exclusiveOrNotList: 'exclusiveOrNot'
        }),
    },
    data() {
        return {
            btnSave: false,//是否待审批按钮
            permisList: [],//图片和视频权限
            allDate: [], //委托日期
            rentTungList: [], //租金类型
            supportingFacilitiesList: [], //配套设施列表
            featuresList: [], //特性列表
            expenseDetailList: [], //费用明细列表
            rentalModeList: [], //出租方式列表
            priceConditionList: [], //价格条件列表
            minimumTenancyList: [], //最短租期列表
            searchHouseType: "", //查询状态房源类型
            areaName: "",
            data: "",
            empId: "",
            isDisabled: true,
            isActive: 0,
            strucIsActive: 0,
            natureIsActive: 0,
            thIsActive: 0,
            propRighNaIsActive: 0,
            mortgageIsActive: 0,
            sexIsActive: 0,
            statusIsActive: 0,
            statusIsActive2: null,
            RelyStreetActive: 0,
            housingData: [], //小区列表
            // buildData: [], //建筑结构列表
            houseInfoList: [], //栋座列表
            staircase: "", //梯
            family: "", //户
            floors: "", //总层数
            unitInfoList: [], //单元列表
            floorNumData: [], //楼层列表
            roomNumData: [], //房间列表
            towardData: [],
            doorRoom: [],
            doorOffice: [],
            doorToilet: [],
            doorBalcony: [],
            buildTypeData: [], //建筑类型列表
            structureData: [], //房屋结构列表
            natureList: [], //性质列表
            decorDegreeList: [], //装修程度列表
            propertyList: [], //产权列表
            buildedAgeList: [], //建筑年代列表
            situationList: [], //房屋现状列表
            thTimeList: [], //腾房时间
            ownerPropeList: [], //房屋权属列表
            propertyRightNatureList: [], //产权性质列表
            mortgageList: [], //查询抵押情况列表
            sourceList: [], //来源列表
            unluckyAbodeList: [], //是否凶宅列表
            businessSectorList: [], //经营行业列表
            applicableToIndustryList: [],
            businessStatusList: [],
            rentFreePeriodUnitList: [],
            houseLevelList: [], //房源类型列表
            payWayList: [], //付款方式列表
            taxPaymentList: [], //税费支付列表
            statusList: [], //业务状态列表

            seeHouseModeList: [], //看房方式列表
            houseTypeFeatures: "", //房源类型特性
            sexList: [], //性别列表
            maritalStatusList: [], //婚姻状况列表
            customerLevelList: [], //客户级别列表
            certificatesTypeList: [], //证件类型列表
            RelyStreetList: [], //是否临街列表
            houseTypelist: [], //房源类型列表
            unitInfoIndex: 0, //单元索引
            floorIndex: 0, //楼层索引
            storeList: [], //门店列表
            towardIdList: [], //朝向列表
            buildInfo: {
                belongFloor: "",//所属楼层
                businessSector: "",
                applicableToIndustry: [],
                businessStatus: "",
                transferFee: "",
                remainingLeaseTerm: "",
                rentFreePeriod: "",
                rentFreePeriodUnit: "",
                specifications: "",
                relatedExpenses: "",
                passengerFlowCrowd: "",

                exclusiveOrNot: '0', //是否独家
                keyCode: "", //新增钥匙编号
                /* 楼盘信息 */
                residentialAreaId: "", //小区
                dicTungId: "", //栋
                dicUnitId: "", //单元
                dicFloorId: "", //楼层
                dicRoomId: "", //房号
                chambersNumber: "", //室数
                officeNumber: "", //厅数
                toiletNumber: "", //卫数
                balconyNumber: "", //阳台数
                decorationDegree: "", //装修程度
                architecturalType: "", //建筑类型
                orientation: "", //朝向
                frontage: "", //是否临街
                rentalArea: "", //出租面积
                years: "", //年代
                estateCertificationNo: "", //产证号
                verificationNo: "", //核验编号
                propertyRight: "", //产权
                property: "", //性质
                houseLevel: "", //房源类型
                source: "", //来源
                unluckyAbode: "",//是否凶宅
                storeId: "", //门店ID
                description: "", //钥匙备注

                /* 业务信息 业主信息 */
                rentalMode: "", //出租方式
                rent: "", //租金
                rentCompany: "", //租金单位
                paymentMethod: "", //付款方式
                name: "", //业主姓名
                sex: "", //业主性别
                marriage: "", //业主婚姻
                level: "", //客源级别
                deposit: "", //租房押金
                floorPrice: "", //底价
                deliveryDate: "", //交付时间
                idType: "", //业主证件类型
                idNumber: "", //业主证件号
                phone: [""], //业主电话
                minimumTenancy: "", //最短租期
                priceTerms: "", //价格条件
                status: "在租", //状态
                // partOwnerName: "", //共有人姓名
                // partOwnerSex: "", //共有人性别
                // partOwnerPhone: [""], //共有人电话
                // partOwnerIdType: "", //共有人证件类型
                // partOwnerIdNumber: "", //共有人证件号
                partOwnerInfo: [
                    {
                        id: "",
                        name: "",
                        sex: "",
                        marriage: "",
                        phone: [""],
                        idType: "",
                        idNumber: "",
                        address: ""
                    }
                ], //共有人信息
                commissionDate: "", //委托日期
                dueDate: "", //到期日期
                houseInspectionMethod: "", //看房方式
                expenseDetail: [], //费用明细
                features: [], //特性
                supportingFacilities: [], //配套设施
                publicRemarks: "", //公开备注
                privateRemarks: "", //保密备注
                /* 发布信息 */
                publishLocation: true, //是否发布
                title: "", //标题
                housingAdvantage: "", //房屋优势
                decorationDescription: "", //装修描述
                houseTypeDes: "", //户型介绍
                analysisTaxation: "", //费税解析
                indoorPicture: "", //室内图片
                apartmentPicture: "", //户型图片
                vrVideo: "", //VR视频
                secretPicture: "", //保密图片

                /* -----------------------------------华丽的分割线----------------------------------- */
                dutyPaidDate: "", //完税
                buildingStructure: "", //建筑结构
                areaMeasureBuild: "", //建筑面积
                // ascriptionEmployeeId: '', // 归属经纪人编号
                residentialAreaName: "",
                id: "",
                transactionType: "", //交易类型
                areaId: "", //区域编号
                areaName: "",
                tradeAreaId: "", //商圈编号
                tradeAreaName: "",
                houseTypeId: "", //户型编号
                floorHeight: "", //层高
                housingStructure: "", //房屋结构
                houseStatus: "", //房屋现状
                vacateTime: "", //腾房时间
                housingOwnership: "", //房屋权属
                giveEvidenceDate: "", //出证日期
                mortgageSituation: "", //抵押情况
                villaHallStructure: "", //厅结构
                undergroundArea: "", //地下面积
                undergroundCondition: "", //地下情况
                gardenArea: "", //花园面积
                parkingNo: "", //车位数量
                villaType: "", //别墅类型
                architecturalStyle: "", //建筑风格
                sceneryType: "", //景观类型
                functionalType: "", //功能类型
                numberPosition: "", //号位
                address: "", //地址
                shopsBay: "", //商铺开间
                shopsDepth: "", //商铺进深
                businessActivities: "", //适合经营
                newAndOldDegree: "", //新旧程度
                fireControl: "", //消防
                bridgeCrane: "", //行车
                elevator: "", //电梯
                enterCart: "", //可进大车
                suitableIndustry: "", //适合行业
                decoration: "", //备注
                propertyRightNature: "", //产权性质
                housingResourceType: "", //房源类型
                keyId: "", //钥匙编号
                totalPrice: "", //总价
                unitPrice: "", //单价
                installmentAmount: "", //分期金额
                taxPayment: "", //税费支付
                taxation: "", //税费
                rentalProperty: "", //租房性质
                propertyFee: "", //物业费
                name: "", //业主姓名
                partOwnerSex: "", //共有人性别
                areaOfUse: "", //套内面积 m²
                areaOfBuilding: "", //建筑面积 m²
                isindoor: false
            },

            dialogTableVisible: false,
            value: "",
            uploadImgVisible: false //图片上传现实隐藏
        };
    },
    components: {
        AddKeyAlert,
        UploadImg
    },
    mounted() {
        this.getApproval();//查询是否待审批
        this.getRentWay(true); //查询出租方式
        this.getPriceCondition(true); //查询价格条件
        this.getexpenseDetailList(); //查询费用明细
        this.getFeaturesList(); //查询特性
        this.getsupportingFacilitiesList(); //查询配套设施列表
        this.getMinimumTenancyList(true); //查询最短租期
        this.getNatureList(); //查询性质
        this.getrentTungList(); //查询租金单位
        let menulist = JSON.parse(localStorage.getItem("menu"));
        menulist.map(item => {
            if (item.name == "房源管理") {
                item.childMenus.map(child => {
                    if (child.name == "租房列表") {
                        child.functions.map(fuc => {
                            this.permisList.push(fuc.functionName);
                        });
                    }
                });
            }
        });
    },
    watch: {
        allDate(val) {
            if (!val) {
                this.buildInfo.commissionDate = null;
                this.buildInfo.dueDate = null;
            }
        }
    },
    methods: {
        getApproval() {
            let params = {
                approvalType: "whether_house"
            }
            this.$post(queryApprovalWhetherOpen, params).then(res => {
                if (res.success) {
                    if (res.data) {
                        this.btnSave = true;
                    }
                } else {
                    this.$message({
                        type: "error",
                        message: res.msg
                    });
                }
            })
        },
        permisShow(data) {
            // 权限配置
            let result = this.permisList.indexOf(data);
            if (result >= 0) {
                return true;
            } else {
                return false;
            }
        },
        addMen(index) {
            let data = {
                id: "",
                name: "",
                sex: "",
                marriage: "",
                phone: [""],
                idType: "",
                idNumber: "",
                address: ""
            };
            if (index !== 0) {
                this.buildInfo.partOwnerInfo.splice(index, 1);
            } else {
                this.buildInfo.partOwnerInfo.push(data);
            }
        },
        // 查询租金单位
        getrentTungList() {
            let params = { code: "rentTung" };
            this.$post(dicGet, params).then(res => {
                if (res.success) {
                    this.rentTungList = res.data;
                } else {
                    this.$message({
                        message: res.msg,
                        type: "error"
                    });
                }
            });
        },
        // 查询配套设施列表
        getsupportingFacilitiesList() {
            let params = { code: "supportingFacilities" };
            this.$post(dicGet, params).then(res => {
                if (res.success) {
                    this.supportingFacilitiesList = res.data;
                } else {
                    this.$message({
                        message: res.msg,
                        type: "error"
                    });
                }
            });
        },
        // 查询特性
        getFeaturesList() {
            let params = { code: "rentalShopFeatures" };
            this.$post(dicGet, params).then(res => {
                if (res.success) {
                    this.featuresList = res.data;
                } else {
                    this.$message({
                        message: res.msg,
                        type: "error"
                    });
                }
            });
        },
        // 查询费用明细
        getexpenseDetailList() {
            let params = { code: "expenseDetail" };
            this.$post(dicGet, params).then(res => {
                if (res.success) {
                    this.expenseDetailList = res.data;
                } else {
                    this.$message({
                        message: res.msg,
                        type: "error"
                    });
                }
            });
        },
        // 查询出租方式列表
        getRentWay(val) {
            if (val) {
                let params = { code: "shopRentalMode" };
                this.$post(dicGet, params).then(res => {
                    if (res.success) {
                        this.rentalModeList = res.data;
                    } else {
                        this.$message({
                            message: "出租方式查询失败",
                            type: "error"
                        });
                    }
                });
            }
        },
        //电话验证
        setTestphone(index, phoneIndex, data, id) {
            let phoneNumber = /^1[3456789]\d{9}$/;
            if (!phoneNumber.test(data)) {
                this.$message({
                    type: "error",
                    message: "请输入正确的手机号"
                });
                return false;
            }
            //查新手机号是否在黑名单
            let params = {
                phone: data
            };
            this.$post(queryByPhoneOrCard, params).then(res => {
                if (res.success) {
                    if (res.data) {
                        this.$confirm(
                            "该手机号在系统中登记异常，请联系管理员！",
                            {
                                confirmButtonText: "确定",
                                cancelButtonText: "取消",
                                showCancelButton: false,
                                type: "warning"
                            }
                        )
                            .then(() => {
                                if (id == 1) {
                                    this.buildInfo.phone.splice(index, 1);
                                    this.buildInfo.phone.push("");
                                } else if (id == 2) {
                                    this.buildInfo.partOwnerInfo[index].phone.splice(
                                        phoneIndex,
                                        1
                                    );
                                    this.buildInfo.partOwnerInfo[index].phone.push("");
                                }
                            })
                            .catch(() => {
                                if (id == 1) {
                                    this.buildInfo.phone.splice(index, 1);
                                    this.buildInfo.phone.push("");
                                } else if (id == 2) {
                                    this.buildInfo.partOwnerInfo[index].phone.splice(
                                        phoneIndex,
                                        1
                                    );
                                    this.buildInfo.partOwnerInfo[index].phone.push("");
                                }
                            });
                    }
                } else {
                    this.$message({
                        type: "error",
                        message: res.msg
                    });
                }
            });
        },
        //身份证验证
        setTestIdnumber(index, data, num) {
            let idNumber = /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
            if (num == 1 && this.buildInfo.idType == "IDENTITY_ID" && data) {
                if (!idNumber.test(data)) {
                    this.$message({
                        type: "error",
                        message: "请输入正确的身份证号"
                    });
                    return false;
                }
                //查新身份证是否在黑名单
                let params = {
                    idNumber: data
                };
                this.$post(queryByPhoneOrCard, params).then(res => {
                    if (res.success) {
                        if (res.data) {
                            this.$confirm(
                                "该身份证号在系统中登记异常，请联系管理员！",
                                {
                                    confirmButtonText: "确定",
                                    cancelButtonText: "取消",
                                    showCancelButton: false,
                                    type: "warning"
                                }
                            )
                                .then(() => {
                                    this.buildInfo.idNumber = "";
                                })
                                .catch(() => {
                                    this.buildInfo.idNumber = "";
                                });
                        }
                    } else {
                        this.$message({
                            type: "error",
                            message: res.msg
                        });
                    }
                });
            } else if (
                num == 2 &&
                this.buildInfo.partOwnerInfo[index].idType == "IDENTITY_ID" && data
            ) {
                if (!idNumber.test(data)) {
                    this.$message({
                        type: "error",
                        message: "请输入正确的身份证号"
                    });
                    return false;
                }
                //查新身份证是否在黑名单
                let params = {
                    idNumber: data
                };
                this.$post(queryByPhoneOrCard, params).then(res => {
                    if (res.success) {
                        if (res.data) {
                            this.$confirm(
                                "该身份证号在系统中登记异常，请联系管理员！",
                                {
                                    confirmButtonText: "确定",
                                    cancelButtonText: "取消",
                                    showCancelButton: false,
                                    type: "warning"
                                }
                            )
                                .then(() => {
                                    this.buildInfo.partOwnerInfo[index].idNumber = "";
                                })
                                .catch(() => {
                                    this.buildInfo.partOwnerInfo[index].idNumber = "";
                                });
                        }
                    } else {
                        this.$message({
                            type: "error",
                            message: res.msg
                        });
                    }
                });
            }
        },
        //添加电话
        deletePhone(index) {
            if (index !== 0) {
                this.buildInfo.phone.splice(index, 1);
            } else {
                if (this.buildInfo.phone.length >= 3) {
                    this.$message({
                        type: "error",
                        message: "最多添加3个电话号码"
                    });
                } else {
                    this.buildInfo.phone.push("");
                }
            }
        },
        //添加共有人电话
        deletePhone1(index, phoneIndex) {
            if (phoneIndex !== 0) {
                this.buildInfo.partOwnerInfo[index].phone.splice(phoneIndex, 1);
            } else {
                if (this.buildInfo.partOwnerInfo[index].phone.length >= 3) {
                    this.$message({
                        type: "error",
                        message: "最多添加3个电话号码"
                    });
                } else {
                    this.buildInfo.partOwnerInfo[index].phone.push("");
                }
            }
        },
        // 获取门店列表
        getStoreList() {
            this.$post(storeFind).then(res => {
                if (res.success) {
                    this.storeList = res.data;
                    // console.log(res.data);
                } else {
                    this.$message({
                        type: "error",
                        message: res.msg
                    });
                }
            });
        },
        //获取单价
        getUnitPrice() {
            if (
                this.buildInfo.areaOfBuilding != "" &&
                this.buildInfo.totalPrice != ""
            ) {
                let price =
                    (this.buildInfo.totalPrice * 10000) / this.buildInfo.areaOfBuilding;
                this.buildInfo.unitPrice = Math.floor(price * 10000) / 10000;
            }
        },
        querySearchAsync(queryString, cb) {
            // 查询小区
            let params = {
                name: queryString,
                "page.pageNumber": 0,
                "page.pageSize": 20
            };
            this.$post(communitynameQuery, params).then(res => {
                if (res.success) {
                    this.housingData = res.data;
                    let restaurants = this.housingData;
                    // let results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants;

                    cb(restaurants);
                } else {
                }
            });
        },

        createStateFilter(queryString) {
            // 过滤小区关键字
            return state => {
                return (
                    state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
                );
            };
        },

        handleSelect(item) {
            this.buildInfo.residentialAreaName = item.name;
            this.buildInfo.residentialAreaId = item.residentialAreaId;
            this.getcommunityDetail();
            this.buildInfo.dicTungId = "";
            this.buildInfo.dicUnitId = "";
            this.buildInfo.dicFloorId = "";
            this.buildInfo.dicRoomId = "";
            this.buildInfo.orientation = "";
            this.buildInfo.chambersNumber = "";
            this.buildInfo.officeNumber = "";
            this.buildInfo.toiletNumber = "";
            this.buildInfo.balconyNumber = "";
            this.buildInfo.floorHeight = "";
            this.buildInfo.buildStructure = "";
        },
        //查询小区详情
        getcommunityDetail() {
            let params = {
                residentialAreaId: this.buildInfo.residentialAreaId
            };
            this.$post(communityDetail, params).then(res => {
                if (res.success) {
                    this.buildInfo.areaId = res.data.areaId;
                    this.buildInfo.areaName = res.data.areaName;
                    this.buildInfo.tradeAreaId = res.data.tradeAreaId;
                    this.buildInfo.tradeAreaName = res.data.tradeAreaName;
                }
            });
        },

        getHouseInfoList(val) {
            // 获取栋楼
            if (val) {
                let params = {
                    residentialAreaId: this.buildInfo.residentialAreaId
                };
                this.$post(tungQuery, params).then(res => {
                    if (res.success) {
                        //  //cosole.log(res, "栋楼");
                        this.houseInfoList = res.data.tungs;
                        // this.getDecorationDegree(true);
                        // this.getProperty(true);
                        // this.getSituation(true);
                        // this.getOwnerProperty(true);
                        // this.getSourceList(true);
                        // this.getUnluckyAbodeList(true);
                        // this.getHouseLevel(true);
                    }
                });
            }
        },
        //获取楼栋信息
        getfloorDetails() {
            //楼栋清理数据
            this.buildInfo.dicUnitId = ""; //单元
            this.buildInfo.dicFloorId = ""; //楼层
            this.buildInfo.dicRoomId = ""; //房号
            this.buildInfo.orientation = ""; //朝向
            this.buildInfo.chambersNumber = "";
            this.buildInfo.officeNumber = "";
            this.buildInfo.toiletNumber = "";
            this.buildInfo.balconyNumber = ""; //户型
            this.houseInfoList.map((item, index) => {
                if (item.tungId == this.buildInfo.dicTungId) {
                    this.staircase = item.elevatorNo;
                    this.family = item.households;
                    this.floors = item.floors;
                    this.buildInfo.buildingStructure = item.buildingStructure;
                    this.getbuildData();
                }
            });
        },
        // 获取单元
        getUnitInfoList(val) {
            if (val) {
                let params = {
                    tungId: this.buildInfo.dicTungId
                };
                this.$post(tungunitQuery, params).then(res => {
                    if (res.success) {
                        this.unitInfoList = res.data.units;
                    }
                });
            }
        },

        changeUnit() {
            // 单元清理数据
            this.buildInfo.dicFloorId = ""; //楼层
            this.buildInfo.dicRoomId = ""; //房号
            this.buildInfo.orientation = ""; //朝向
            this.buildInfo.chambersNumber = "";
            this.buildInfo.officeNumber = "";
            this.buildInfo.toiletNumber = "";
            this.buildInfo.balconyNumber = ""; //户型
            this.unitInfoList.map((item, index) => {
                if (item.unitId === this.buildInfo.dicUnitId) {
                    this.floorNumData = item.floors;
                }
            });
        },

        changefloor() {
            //楼层清理数据
            this.buildInfo.dicRoomId = ""; //房号
            this.buildInfo.orientation = ""; //朝向
            this.buildInfo.chambersNumber = "";
            this.buildInfo.officeNumber = "";
            this.buildInfo.toiletNumber = "";
            this.buildInfo.balconyNumber = ""; //户型
            this.floorNumData.map((item, index) => {
                if (item.floorId === this.buildInfo.dicFloorId) {
                    this.roomNumData = item.rooms;
                    for (let i = this.roomNumData.length - 1; i >= 0; i--) {
                        if (this.roomNumData[i].roomId === 0) {
                            this.roomNumData.splice(i, 1);
                        }
                    }
                }
            });
        },

        searchHousetype() {
            //房号清理数据
            this.buildInfo.orientation = ""; //朝向
            this.buildInfo.chambersNumber = "";
            this.buildInfo.officeNumber = "";
            this.buildInfo.toiletNumber = "";
            this.buildInfo.balconyNumber = ""; //户型
            let params = {
                roomId: this.buildInfo.dicRoomId,
                housingProperty: "RENTING"
            };
            this.$post(houseTypeFind, params).then(res => {
                if (res.success) {
                    this.$post(checkHousing, params).then(res => {
                        if (res.success) {
                        } else {
                            this.$message({
                                type: "error",
                                message: "该房源已存在"
                            });
                            this.buildInfo.dicRoomId = ""; //房号
                            this.buildInfo.orientation = ""; //朝向
                            this.buildInfo.chambersNumber = "";
                            this.buildInfo.officeNumber = "";
                            this.buildInfo.toiletNumber = "";
                            this.buildInfo.balconyNumber = ""; //户型
                        }
                    });
                    this.buildInfo.rentalArea = res.data.areaOfBuilding; //建筑面积
                    // this.buildInfo.areaOfUse = res.data.areaOfUse; //套内面积
                    this.houseTypelist = res.data;
                    this.buildInfo.orientation = res.data.orientation;
                    this.buildInfo.chambersNumber = res.data.chambersNumber;
                    this.buildInfo.officeNumber = res.data.officeNumber;
                    this.buildInfo.toiletNumber = res.data.toiletNumber;
                    this.buildInfo.balconyNumber = res.data.balconyNumber;
                    this.buildInfo.houseTypeId = res.data.houseTypeId;
                } else {
                    this.$message({
                        type: "error",
                        message: res.msg
                    });
                }
            });
        },

        getDoorModelList(val, type) {
            //cosole.log(val);
            //cosole.log(type);
            if (val) {
                if (type == 0) {
                    let params = {
                        employeeId: this.empId,
                        areaId: this.buildInfo.areaId,
                        chambersNumber: "", //室数
                        officeNumber: "", //厅数
                        toiletNumber: "", //卫数
                        balconyNumber: "", //阳台数
                        orientation: this.buildInfo.orientation
                    };
                    getDoorModelInfo(params).then(res => {
                        //cosole.log("户型的详细信息");
                        //cosole.log(res);
                        this.doorRoom = res.data;
                    });
                } else if (type == 1) {
                    let params = {
                        employeeId: this.empId,
                        areaId: this.buildInfo.areaId,
                        chambersNumber: this.buildInfo.chambersNumber, //室数
                        officeNumber: "", //厅数
                        toiletNumber: "", //卫数
                        balconyNumber: "", //阳台数
                        orientation: this.buildInfo.orientation
                    };
                    getDoorModelInfo(params).then(res => {
                        //cosole.log("户型的详细信息");
                        //cosole.log(res);
                        this.doorOffice = res.data;
                    });
                } else if (type == 2) {
                    let params = {
                        employeeId: this.empId,
                        areaId: this.buildInfo.areaId,
                        chambersNumber: this.buildInfo.chambersNumber, //室数
                        officeNumber: this.buildInfo.officeNumber, //厅数
                        toiletNumber: "", //卫数
                        balconyNumber: "", //阳台数
                        orientation: this.buildInfo.orientation
                    };
                    getDoorModelInfo(params).then(res => {
                        //cosole.log("户型的详细信息");
                        //cosole.log(res);
                        this.doorToilet = res.data;
                    });
                } else if (type == 3) {
                    let params = {
                        employeeId: this.empId,
                        areaId: this.buildInfo.areaId,
                        chambersNumber: this.buildInfo.chambersNumber, //室数
                        officeNumber: this.buildInfo.officeNumber, //厅数
                        toiletNumber: this.buildInfo.toiletNumber, //卫数
                        balconyNumber: "", //阳台数
                        orientation: this.buildInfo.orientation
                    };
                    getDoorModelInfo(params).then(res => {
                        //cosole.log("户型的详细信息");
                        //cosole.log(res);
                        this.doorBalcony = res.data;
                    });
                }
            }
        },

        getbuildData() {
            // 查询建筑结构
            let params = { code: "buildingStructure" };
            this.$post(dicGet, params).then(res => {
                if (res.success) {
                    res.data.map((item, index) => {
                        if (this.buildInfo.buildingStructure == item.value) {
                            this.buildInfo.buildingStructure = item.valueDesc;
                        }
                    });
                } else {
                    this.$message({
                        message: res.msg,
                        type: "error"
                    });
                }
            });
        },
        getbuildlist() {
            // 查询朝向
            let params = { code: "orientation" };
            this.$post(dicGet, params).then(res => {
                if (res.success) {
                    this.towardIdList = res.data;
                    console.log(123123, this.towardIdList);
                    // res.data.map((item, index) => {
                    //   if (this.buildInfo.buildingStructure == item.value) {
                    //     this.buildInfo.buildingStructure = item.valueDesc;
                    //   }
                    // });
                } else {
                    this.$message({
                        message: res.msg,
                        type: "error"
                    });
                }
            });
        },

        getBuildingType() {
            // 查询建筑类型
            let params = { code: "shopAreaArchitecturalType" };
            this.$post(dicGet, params).then(res => {
                if (res.success) {
                    this.buildTypeData = res.data;
                } else {
                    this.$message({
                        message: res.msg,
                        type: "error"
                    });
                }
            });
        },
        // 查询房屋结构
        getBuildingStructure() {
            let params = { code: "housingStructure" };
            this.$post(dicGet, params).then(res => {
                if (res.success) {
                    this.structureData = res.data;
                    // this.buildInfo.housingStructure = this.structureData[0].value;
                } else {
                    this.$message({
                        message: res.msg,
                        type: "error"
                    });
                }
            });
        },
        //查询最短租期 minimumTenancyList
        getMinimumTenancyList(val) {
            if (val) {
                let params = { code: "minimumTenancy" };
                this.$post(dicGet, params).then(res => {
                    if (res.success) {
                        this.minimumTenancyList = res.data;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: "error"
                        });
                    }
                });
            }
        },
        getNatureList() {
            // 查询性质
            let params = { code: "property" };
            this.$post(dicGet, params).then(res => {
                if (res.success) {
                    this.natureList = res.data;
                    // this.buildInfo.property = this.natureList[0].value;
                    //  //cosole.log(111111, this.natureList);
                } else {
                    this.$message({
                        message: res.msg,
                        type: "error"
                    });
                }
            });
        },

        getDecorationDegree(val) {
            // 查询装修程度
            if (val) {
                let params = { code: "decorationDegree" };
                this.$post(dicGet, params).then(res => {
                    if (res.success) {
                        this.decorDegreeList = res.data;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: "error"
                        });
                    }
                });
            }
        },

        getProperty(val) {
            // 查询产权
            if (val) {
                let params = { code: "shopPropertyRight" };
                this.$post(dicGet, params).then(res => {
                    if (res.success) {
                        this.propertyList = res.data;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: "error"
                        });
                    }
                });
            }
        },
        // 查询建筑年代
        getBuildedAge(val) {
            if (val) {
                let params = { code: "buildAges" };
                this.$post(dicGet, params).then(res => {
                    if (res.success) {
                        this.buildedAgeList = res.data;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: "error"
                        });
                    }
                });
            }
        },

        // 查询房屋现状
        getSituation(val) {
            if (val) {
                let params = { code: "houseStatus" };
                this.$post(dicGet, params).then(res => {
                    if (res.success) {
                        this.situationList = res.data;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: "error"
                        });
                    }
                });
            }
        },
        // 查询腾房日期
        getThTime() {
            let params = { code: "vacateTime" };
            this.$post(dicGet, params).then(res => {
                if (res.success) {
                    this.thTimeList = res.data;
                    // this.buildInfo.vacateTime = this.thTimeList[0].value;
                } else {
                    this.$message({
                        message: res.msg,
                        type: "error"
                    });
                }
            });
        },
        // 查询房屋权属
        getOwnerProperty(val) {
            if (val) {
                let params = { code: "housingOwnership" };
                this.$post(dicGet, params).then(res => {
                    if (res.success) {
                        this.ownerPropeList = res.data;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: "error"
                        });
                    }
                });
                // })
            }
        },
        // 查询产权性质
        getPropRightNature() {
            let params = { code: "natureRights" };
            this.$post(dicGet, params).then(res => {
                if (res.success) {
                    this.propertyRightNatureList = res.data;
                    // this.buildInfo.propertyRightNature = res.data[0].value;
                } else {
                    this.$message({
                        message: res.msg,
                        type: "error"
                    });
                }
            });
        },

        getMortgageList() {
            // 查询抵押
            this.mortgageList = [
                { value: "SECURED", valueDesc: "有抵押" },
                { value: "UNSECURED", valueDesc: "无抵押" }
            ];
            // this.buildInfo.mortgageSituation = this.mortgageList[0].value;
        },

        getRelyStreetList() {
            // 查询是否临街
            this.RelyStreetList = [
                { value: "YES", valueDesc: "是" },
                { value: "NO", valueDesc: "否" }
            ];
            // this.buildInfo.frontage = this.RelyStreetList[0].value;
        },
        // 查询来源
        getSourceList(val) {
            if (val) {
                let params = { code: "source" };
                this.$post(dicGet, params).then(res => {
                    if (res.success) {
                        this.sourceList = res.data;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: "error"
                        });
                    }
                });
            }
        },
        // 查询是否凶宅
        getUnluckyAbodeList(val) {
            if (val) {
                let params = { code: "unluckyAbode" };
                this.$post(dicGet, params).then(res => {
                    if (res.success) {
                        this.unluckyAbodeList = res.data;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: "error"
                        });
                    }
                });
            }
        },
        //查询经营行业
        getBusinessSector(val) {
            if (val) {
                let params = { code: "businessSector" };
                this.$post(dicGet, params).then(res => {
                    if (res.success) {
                        this.businessSectorList = res.data;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: "error"
                        });
                    }
                });
            }
        },
        //查询适用于行业
        getApplicableToIndustry(val) {
            if (val) {
                let params = { code: "applicableToIndustry" };
                this.$post(dicGet, params).then(res => {
                    if (res.success) {
                        this.applicableToIndustryList = res.data;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: "error"
                        });
                    }
                });
            }
        },
        //查询经营状态
        getBusinessStatus(val) {
            if (val) {
                let params = { code: "businessStatus" };
                this.$post(dicGet, params).then(res => {
                    if (res.success) {
                        this.businessStatusList = res.data;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: "error"
                        });
                    }
                });
            }
        },
        //查询经营状态
        getRentFreePeriodUnit(val) {
            if (val) {
                let params = { code: "rentFreePeriodUnit" };
                this.$post(dicGet, params).then(res => {
                    if (res.success) {
                        this.rentFreePeriodUnitList = res.data;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: "error"
                        });
                    }
                });
            }
        },
        // 查询房源类型
        getHouseLevel(val) {
            if (val) {
                let params = { code: "houseLevel" };
                this.$post(dicGet, params).then(res => {
                    if (res.success) {
                        this.houseLevelList = res.data;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: "error"
                        });
                    }
                });
            }
        },
        // 查询付款方式
        getPayWayList(val) {
            if (val) {
                let params = { code: "rentingPaymentMethod" };
                this.$post(dicGet, params).then(res => {
                    if (res.success) {
                        this.payWayList = res.data;
                    } else {
                        this.$message({
                            message: "查询付款方式失败",
                            type: "error"
                        });
                    }
                });
            }
        },

        // 查询税费支付列表
        gettaxPaymentList(val) {
            if (val) {
                let params = { code: "taxPayment" };
                this.$post(dicGet, params).then(res => {
                    if (res.success) {
                        this.taxPaymentList = res.data;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: "error"
                        });
                    }
                });
            }
        },

        // 查询业务状态
        getStatusList(val) {
            if (val) {
                let params = { code: "rentingBusinessStatus" };
                this.$post(dicGet, params).then(res => {
                    if (res.success) {
                        this.statusList = res.data;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: "error"
                        });
                    }
                });
            }
        },
        // 查询价格条件
        getPriceCondition(val) {
            if (val) {
                let params = { code: "priceTerms" };
                this.$post(dicGet, params).then(res => {
                    if (res.success) {
                        this.priceConditionList = res.data;
                    } else {
                        this.$message({
                            message: "查询价格条件失败",
                            type: "error"
                        });
                    }
                });
            }
        },
        // 查询看房方式
        getSeeHouseMode(val) {
            if (val) {
                let params = { code: "houseInspectionMethod" };
                this.$post(dicGet, params).then(res => {
                    if (res.success) {
                        this.seeHouseModeList = res.data;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: "error"
                        });
                    }
                });
            }
        },
        // 查询性别
        getSexList() {
            this.sexList = [
                { value: "MALE", valueDesc: "男" },
                { value: "FEMALE", valueDesc: "女" }
            ];
            // this.buildInfo.sex = this.sexList[0].value;
            // this.buildInfo.partOwnerSex = this.sexList[0].value;
        },
        // 查询婚姻状况
        getMaritalStatus() {
            let params = { code: "marriage" };
            this.$post(dicGet, params).then(res => {
                if (res.success) {
                    this.maritalStatusList = res.data;
                    // this.buildInfo.marriage = this.maritalStatusList[0].value;
                } else {
                    this.$message({
                        message: res.msg,
                        type: "error"
                    });
                }
            });
        },

        getCustomerLevel(val) {
            // 查询客户级别
            if (val) {
                this.$post(customerLevel).then(res => {
                    if (res.success) {
                        this.customerLevelList = res.data;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: "error"
                        });
                    }
                });
            }
        },

        getCertificatesType(val) {
            // 查询证件类型
            if (val) {
                let params = { code: "certificatesType" };
                this.$post(dicGet, params).then(res => {
                    if (res.success) {
                        this.certificatesTypeList = res.data;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: "error"
                        });
                    }
                });
            }
        },
        // 选择建筑类型
        chouseType(i, data) {
            //cosole.log(data);
            this.isActive = i;
            this.buildInfo.architecturalType = data.value;
        },
        // 选择房屋结构
        chouseStruceture(i, data) {
            //cosole.log(data);
            this.strucIsActive = i;
            this.buildInfo.housingStructure = data.value;
        },
        // 选择性质
        chouseNature(i, data) {
            //cosole.log(data);
            this.natureIsActive = i;
            this.buildInfo.property = data.value;
        },
        // 选择腾房时间
        chouseThTime(i, data) {
            //cosole.log(data);
            this.thIsActive = i;
            this.buildInfo.vacateTime = data.value;
        },
        // 选择是否临街
        chourseRelyStreet(i, data) {
            this.RelyStreetActive = i;
            this.buildInfo.frontage = data.value;
        },
        // 选择产权性质
        chouseRightNature(i, data) {
            this.propRighNaIsActive = i;
            this.buildInfo.propertyRightNature = data.value;
        },
        // 选择抵押情况
        chourseMortgage(i, data) {
            this.mortgageIsActive = i;
            this.buildInfo.mortgageSituation = data.value;
        },
        // 选择特性
        // activeIsShow: function(i, item) {
        //   this.featuresList[i].isActive = !this.featuresList[i].isActive;
        //   if (this.buildInfo.features.indexOf(item.value) == -1) {
        //     this.buildInfo.features.push(item.value);
        //   } else if (this.buildInfo.features.indexOf(item.value) > -1) {
        //     this.buildInfo.features.splice(
        //       this.buildInfo.features.indexOf(item.value),
        //       1
        //     );
        //   }
        // },
        // 选择费用明细
        // activeIsShow1: function(i, item) {
        //   this.expenseDetailList[i].isActive = !this.expenseDetailList[i].isActive;
        //   if (this.buildInfo.expenseDetail.indexOf(item.value) == -1) {
        //     this.buildInfo.expenseDetail.push(item.value);
        //   } else if (this.buildInfo.expenseDetail.indexOf(item.value) > -1) {
        //     this.buildInfo.expenseDetail.splice(
        //       this.buildInfo.expenseDetail.indexOf(item.value),
        //       1
        //     );
        //   }
        // },
        // 选择配套设施
        // activeIsShow2: function(i, item) {
        //   this.supportingFacilitiesList[i].isActive = !this
        //     .supportingFacilitiesList[i].isActive;
        //   if (this.buildInfo.supportingFacilities.indexOf(item.value) == -1) {
        //     this.buildInfo.supportingFacilities.push(item.value);
        //   } else if (this.buildInfo.supportingFacilities.indexOf(item.value) > -1) {
        //     this.buildInfo.supportingFacilities.splice(
        //       this.buildInfo.supportingFacilities.indexOf(item.value),
        //       1
        //     );
        //   }
        // },
        // 选择性别
        chouseSex(i, data) {
            this.sexIsActive = i;
            this.buildInfo.sex = data.value;
            //  //cosole.log(this.buildInfo.sex);
        },
        chouseSex2(i, data) {
            if (this.buildInfo.partOwnerSex == data.value) {
                this.statusIsActive2 = null;
                this.buildInfo.partOwnerSex = "";
            } else {
                this.statusIsActive2 = i;
                this.buildInfo.partOwnerSex = data.value;
            }
            // this.statusIsActive2 = i;
            // this.buildInfo.partOwnerSex = data.value;
            //  //cosole.log(this.buildInfo.commonOwnerSex);
        },
        // 选择婚姻状况
        chouseStatue(i, data) {
            this.statusIsActive = i;
            this.buildInfo.marriage = data.value;
            //cosole.log(this.buildInfo.maritalStatus);
        },
        getRoomNum(data) {
            this.roomNumData = data.findBuildCellFloor;
        },

        // 取消保存
        removeSaveBtn() {
            this.$store.commit("delete_tabs", this.$route.path);
            this.$router.push({ path: "/rentShop" });
        },
        addHouse(btnType) {
            //提交前验证
            if (!this.buildInfo.residentialAreaName) {
                this.$message({
                    type: "error",
                    message: "房源地址不能为空"
                });
                return;
            }
            if (!this.buildInfo.rentalArea) {
                this.$message({
                    type: "error",
                    message: "出租面积不能为空"
                });
                return;
            }
            // if (
            //     !this.buildInfo.chambersNumber &&
            //     !this.buildInfo.officeNumber &&
            //     !this.buildInfo.toiletNumber &&
            //     !this.buildInfo.balconyNumber
            // ) {
            //     this.$message({
            //         type: "error",
            //         message: "请完善户型信息"
            //     });
            //     return;
            // }
            // if (!this.buildInfo.orientation) {
            //     this.$message({
            //         type: "error",
            //         message: "朝向不能为空"
            //     });
            //     return;
            // }
            if (!this.buildInfo.decorationDegree) {
                this.$message({
                    type: "error",
                    message: "装修程度不能为空"
                });
                return;
            }
            if (!this.buildInfo.architecturalType) {
                this.$message({
                    type: "error",
                    message: "建筑类型不能为空"
                });
                return;
            }
            if (!this.buildInfo.propertyRight) {
                this.$message({
                    type: "error",
                    message: "产权不能为空"
                });
                return;
            }
            if (!this.buildInfo.houseLevel) {
                this.$message({
                    type: "error",
                    message: "房源类型不能为空"
                });
                return;
            }
            if (!this.buildInfo.rentalMode) {
                this.$message({
                    type: "error",
                    message: "出租方式不能为空"
                });
                return;
            }
            if (!this.buildInfo.rent) {
                this.$message({
                    type: "error",
                    message: "租金不能为空"
                });
                return;
            }
            if (!this.buildInfo.rentCompany) {
                this.$message({
                    type: "error",
                    message: "租金单位不能为空"
                });
                return;
            }
            if (!this.buildInfo.rentFreePeriod && this.buildInfo.rentFreePeriodUnit) {
                this.$message({
                    type: "error",
                    message: "免租期不能为空"
                });
                return;
            }
            if (this.buildInfo.rentFreePeriod && !this.buildInfo.rentFreePeriodUnit) {
                this.$message({
                    type: "error",
                    message: "免租期单位不能为空"
                });
                return;
            }

            if (!this.buildInfo.paymentMethod) {
                this.$message({
                    type: "error",
                    message: "付款方式不能为空"
                });
                return;
            }
            if (this.buildInfo.features.length == 0) {
                this.$message({
                    type: "error",
                    message: "特性不能为空"
                });
                return;
            }
            if (this.buildInfo.supportingFacilities.length == 0) {
                this.$message({
                    type: "error",
                    message: "配套设施不能为空"
                });
                return;
            }
            if (this.buildInfo.phone[0] == "") {
                if (this.buildInfo.rentalMode == 'SUBLEASE_WHOLE_RENT' || this.buildInfo.rentalMode == 'SUBLEASE_AND_JOINT_TENANCY') {
                    this.$message({
                        type: "error",
                        message: "转租者电话不能为空"
                    });
                } else {
                    this.$message({
                        type: "error",
                        message: "业主电话不能为空"
                    });
                }

                return;
            }
            this.buildInfo.housingResourceType = "SHOPS";
            this.buildInfo.housingProperty = "SHOP_RENTAL";
            this.buildInfo.transactionType = "LEASE";
            if (this.allDate) {
                this.buildInfo.commissionDate = this.allDate[0];
                this.buildInfo.dueDate = this.allDate[1];
            }

            let params = Object.assign({}, this.buildInfo);
            if (btnType == "add") {
                params.applyStatus = "TO_BE_SUBMITTED"
            } else if (btnType == "save") {
                params.applyStatus = "TO_BE_AUDITED"
            }
            if (params.features.length != 0) {
                params.features = params.features.join(",");
            }
            if (params.applicableToIndustry.length != 0) {
                params.applicableToIndustry = params.applicableToIndustry.join(",");
            }
            if (this.buildInfo.expenseDetail.length > 0) {
                params.expenseDetail = this.buildInfo.expenseDetail.join(",");
            }
            if (this.buildInfo.supportingFacilities.length > 0) {
                params.supportingFacilities = this.buildInfo.supportingFacilities.join(
                    ","
                );
            }

            if (this.buildInfo.indoorPicture) {
                params.indoorPicture = JSON.stringify(this.buildInfo.indoorPicture);
            } else {
                params.indoorPicture = "false";
            }
            if (this.buildInfo.apartmentPicture) {
                params.apartmentPicture = JSON.stringify(
                    this.buildInfo.apartmentPicture
                );
            } else {
                params.apartmentPicture = "false";
            }
            if (this.buildInfo.vrVideo) {
                params.vrVideo = JSON.stringify(this.buildInfo.vrVideo);
            } else {
                params.vrVideo = "false";
            }
            if (this.buildInfo.secretPicture) {
                params.secretPicture = JSON.stringify(this.buildInfo.secretPicture);
            } else {
                params.secretPicture = "false";
            }

            // for (let i = this.buildInfo.phone.length - 1; i >= 0; i--) {
            //   if (i !== 0 && this.buildInfo.phone[i] === "") {
            //     this.buildInfo.phone.splice(i, 1);
            //   }
            // }
            // for (let i = this.buildInfo.partOwnerPhone.length - 1; i >= 0; i--) {
            //   if (i !== 0 && this.buildInfo.partOwnerPhone[i] === "") {
            //     this.buildInfo.partOwnerPhone.splice(i, 1);
            //   }
            // }
            //默认状态
            // if (this.buildInfo.status == "在租") {
            //   params.status = "RENTING";
            // }
            //电话
            params.phone = this.buildInfo.phone.join(",");
            // if (params.exclusiveOrNot && params.exclusiveOrNot !== '2') {
            //     if (!params.commissionDate && !params.dueDate) {
            //         this.$message({
            //             type: "error",
            //             message: "请输入委托日期"
            //         });
            //         return;
            //     }
            // }
            // 共有人电话
            params.partOwnerInfo = JSON.stringify(params.partOwnerInfo);
            this.$post(houseAdd, params).then(res => {
                if (res.success) {
                    this.$message({
                        type: "success",
                        message: res.msg
                    });
                    this.$router.push({ path: "rentShop" });
                    this.$store.commit("delete_tabs", "/addRentShop");
                    this.$store.commit("delete_clude", "/addRentShop");
                } else {
                    this.$message({
                        type: "error",
                        message: res.msg
                    });
                }
            });
        },

        closeBtn() {
            this.imgs = [];
            this.upLoadUrl = [];
            this.isSave = false;
        },

        showPicturList(data) {
            if (data == "indoorPicture") {
                this.isindoor = true;
            } else {
                this.isindoor = false;
            }
            this.imgType = data;
            this.uploadImgVisible = true;
        },

        // 图片保存
        upLoadingBtn(data) {
            data.splice(data.length - 1, 1);
            if (!this.buildInfo[this.imgType]) {
                this.buildInfo[this.imgType] = [...data];
            } else {
                this.buildInfo[this.imgType] = this.buildInfo[this.imgType].concat(
                    ...data
                );
            }
            this.uploadImgVisible = false;
        }
    }
};
</script>
<style lang="less">
.rentShop_add {
    margin: 14px;
    background: #fff;
    padding: 27px;

    ul,
    li {
        padding: 0;
        margin: 0;
    }

    .txthidden {
        visibility: hidden;
    }

    .ok {
        color: red;
        position: absolute;
        left: -8px;
    }

    .owner_information_one {
        border: 1px solid #e1e1e1;

        >h3 {
            height: 40px;
            color: #333333;
            font-size: 16px;
            font-weight: bold;
            display: flex;
            align-items: center;
            background: #f2f4ff;
            padding-left: 17px;

            i {
                width: 6px;
                height: 16px;
                background: rgba(94, 117, 230, 1);
                border-radius: 3px;
                margin-right: 10px;
            }
        }

        .owner_info_list {
            padding: 12px 20px;
            color: #333333;
            font-size: 16px;
            border-bottom: 1px solid #e1e1e1;

            .owner_info_list_one {
                display: flex;

                li {
                    margin-right: 1%;
                    flex: 1;
                    display: flex;
                    align-items: center;

                    .title {
                        font-size: 14px;
                        min-width: 85px;
                        position: relative;
                    }

                    .el-input {
                        .el-input__inner {
                            background: none;
                            height: 30px;
                            line-height: 30px;
                            border: none;
                            padding: 0;
                        }
                    }

                    .el-select {
                        .el-input__inner {
                            height: 30px;
                            line-height: 30px;
                            border: none;
                            padding: 0;
                        }

                        .el-input__icon {
                            height: 30px;
                            line-height: 30px;
                        }
                    }

                    .el-date-editor {
                        .el-input__inner {
                            height: 30px;
                            line-height: 30px;
                            border: none;
                            padding: 0;
                        }

                        .el-input__icon {
                            height: 30px;
                            line-height: 30px;
                        }

                        .el-input__prefix {
                            display: none;
                        }
                    }
                }
            }
        }

        .owner_info_list:nth-child(2) {
            .owner_info_list_one {
                li:nth-child(2) {
                    margin-right: 2%;
                    flex: 2;
                }
            }
        }

        .owner_info_list:last-child {
            border: none;
        }
    }

    .owner_information_two {
        border: 1px solid #e1e1e1;

        >h3 {
            height: 40px;
            color: #333333;
            font-size: 16px;
            font-weight: bold;
            display: flex;
            align-items: center;
            background: #f2f4ff;
            padding-left: 17px;

            i {
                width: 6px;
                height: 16px;
                background: rgba(94, 117, 230, 1);
                border-radius: 3px;
                margin-right: 10px;
            }
        }

        .owner_info_list {
            padding: 12px 20px;
            color: #333333;
            font-size: 16px;
            border-bottom: 1px solid #e1e1e1;

            .owner_info_list_one {
                display: flex;

                li {
                    flex: 1;
                    display: flex;
                    align-items: center;

                    .title {
                        font-size: 14px;
                        min-width: 85px;
                        position: relative;
                    }

                    .lastUnits {
                        font-size: 14px;
                        min-width: 40px;
                        text-align: right;
                    }

                    .el-input {
                        .el-input__inner {
                            background: none;
                            height: 30px;
                            line-height: 30px;
                            border: none;
                            padding: 0;
                        }
                    }

                    .el-select {
                        .el-input__inner {
                            height: 30px;
                            line-height: 30px;
                            border: none;
                            padding: 0;
                        }

                        .el-input__icon {
                            height: 30px;
                            line-height: 30px;
                        }
                    }

                    .el-date-editor {
                        width: auto;

                        .el-input__inner {
                            height: 30px;
                            line-height: 30px;
                            border: none;
                            padding: 0;
                        }

                        .el-input__icon {
                            height: 30px;
                            line-height: 30px;
                        }

                        .el-input__prefix {
                            display: none;
                        }
                    }
                }
            }
        }

        .owner_info_list:nth-child(2) {
            li:nth-child(2) {
                .el-select__tags {
                    max-width: 132px !important;
                }
            }
        }

        .owner_info_list:nth-child(4) {
            .owner_info_list_one {
                li:nth-child(4) {
                    .el-date-editor {
                        border: none;
                        height: 30px;

                        .el-range-separator {
                            height: 30px;
                            line-height: 30px;
                        }
                    }
                }
            }
        }

        .owner_info_list:nth-child(5) {
            .owner_info_list_one {
                li {
                    padding-right: 2%;

                    .title {
                        font-size: 14px;
                        min-width: 70px;
                    }

                    .el-input {
                        .el-input__inner {
                            border: 1px solid #dcdfe6;
                            padding-left: 10px;
                        }
                    }

                    .el-select {
                        width: 100%;

                        .el-input {
                            .el-input__inner {
                                padding-left: 10px;
                                background: #f5f5f5;
                            }
                        }
                    }
                }

                li:nth-child(1) {
                    .title {
                        font-size: 14px;
                    }
                }
            }
        }

        .owner_info_list:nth-child(6) {
            .owner_info_list_one {
                li {
                    padding-right: 2%;

                    .title {
                        font-size: 14px;
                        min-width: 126px;
                    }

                    .el-select {
                        width: 100%;

                        .el-input {
                            .el-input__inner {
                                padding-left: 10px;
                                background: #f5f5f5;
                            }
                        }
                    }
                }

                li:nth-child(2) {
                    .title {
                        font-size: 14px;
                        min-width: 98px;
                    }
                }
            }
        }

        .owner_info_list:nth-child(7) {
            padding: 0;

            .owner_info_list_one {
                li {
                    flex: 1;
                    align-items: flex-start;
                    min-height: 80px;
                    border-right: 1px solid #e1e1e1;
                    padding: 12px 20px;
                    margin: 0;

                    .el-textarea {
                        .el-textarea__inner {
                            border: none;
                        }
                    }
                }

                li:last-child {
                    border: none;
                }
            }
        }

        .owner_info_list:last-child {
            border: none;
        }
    }

    .owner_information_three {
        border: 1px solid #e1e1e1;

        >h3 {
            height: 40px;
            color: #333333;
            font-size: 16px;
            font-weight: bold;
            display: flex;
            align-items: center;
            background: #f2f4ff;
            padding-left: 17px;

            i {
                width: 6px;
                height: 16px;
                background: rgba(94, 117, 230, 1);
                border-radius: 3px;
                margin-right: 10px;
            }
        }

        .owner_info_list {
            color: #333333;
            font-size: 16px;
            border-bottom: 1px solid #e1e1e1;

            .owner_info_list_one {
                display: flex;

                li {
                    display: flex;
                    align-items: center;

                    .title {
                        font-size: 14px;
                        min-width: 85px;
                        position: relative;
                    }

                    .lastUnits {
                        font-size: 14px;
                        min-width: 40px;
                        text-align: right;
                    }

                    .el-input {
                        .el-input__inner {
                            background: none;
                            height: 30px;
                            line-height: 30px;
                            border: none;
                            padding: 0;
                        }
                    }

                    .el-select {
                        .el-input__inner {
                            height: 30px;
                            line-height: 30px;
                            border: none;
                            padding: 0;
                        }

                        .el-input__icon {
                            height: 30px;
                            line-height: 30px;
                        }
                    }

                    .el-date-editor {
                        .el-input__inner {
                            height: 30px;
                            line-height: 30px;
                            border: none;
                            padding: 0;
                        }

                        .el-input__icon {
                            height: 30px;
                            line-height: 30px;
                        }

                        .el-input__prefix {
                            display: none;
                        }
                    }
                }

                li:nth-child(1) {
                    justify-content: center;
                    width: 6%;
                    border-right: 1px solid #e1e1e1;

                    >span {
                        font-weight: bold;
                    }
                }

                li:nth-child(2) {
                    width: 94%;
                    display: block;

                    .text {
                        padding: 12px 20px;
                        border-bottom: 1px solid #e1e1e1;
                        display: flex;
                        align-items: center;

                        .text_item {
                            flex: 1;
                            display: flex;
                            align-items: center;
                        }

                        .text_item:last-child {
                            flex: 2;
                        }
                    }

                    .text:nth-child(2) {
                        .text_item {
                            flex: 3;
                            display: flex;
                            align-items: center;

                            .input_in_text {
                                display: flex;

                                .addPhone {
                                    display: flex;
                                    align-items: center;
                                }
                            }
                        }

                        .text_item:last-child {
                            flex: 2;
                        }
                    }

                    .text:last-child {
                        border: none;
                    }
                }
            }
        }

        .owner_info_list:last-child {
            border: none;
        }
    }

    .owner_information_four {
        border: 1px solid #e1e1e1;

        >h3 {
            height: 40px;
            color: #333333;
            font-size: 16px;
            font-weight: bold;
            display: flex;
            align-items: center;
            background: #f2f4ff;
            padding-left: 17px;

            i {
                width: 6px;
                height: 16px;
                background: rgba(94, 117, 230, 1);
                border-radius: 3px;
                margin-right: 10px;
            }
        }

        .owner_info_list {
            padding: 12px 20px;
            color: #333333;
            font-size: 16px;
            border-bottom: 1px solid #e1e1e1;

            .owner_info_list_one {
                display: flex;

                li {
                    width: 50%;
                    display: flex;
                    align-items: center;

                    .title {
                        font-size: 14px;
                        min-width: 85px;
                        position: relative;
                    }

                    .lastUnits {
                        font-size: 14px;
                        min-width: 40px;
                        text-align: right;
                    }

                    .el-input {
                        .el-input__inner {
                            background: #f5f5f5;
                            height: 30px;
                            line-height: 30px;
                            border: none;
                            padding: 0;
                        }
                    }

                    .el-select {
                        .el-input__inner {
                            height: 30px;
                            line-height: 30px;
                            border: none;
                            padding: 0;
                        }

                        .el-input__icon {
                            height: 30px;
                            line-height: 30px;
                        }
                    }

                    .el-date-editor {
                        .el-input__inner {
                            height: 30px;
                            line-height: 30px;
                            border: none;
                            padding: 0;
                        }

                        .el-input__icon {
                            height: 30px;
                            line-height: 30px;
                        }

                        .el-input__prefix {
                            display: none;
                        }
                    }
                }
            }
        }

        .owner_info_list:nth-child(3) {
            padding: 0;

            .owner_info_list_one {
                li {
                    align-items: flex-start;
                    min-height: 80px;
                    width: 100%;
                    border-right: 1px solid #e1e1e1;
                    padding: 12px 20px;
                    margin: 0;

                    .el-textarea {
                        .el-textarea__inner {
                            border: none;
                        }
                    }
                }

                li:last-child {
                    border: none;
                }
            }
        }

        .owner_info_list:nth-child(4) {
            padding: 0;

            .owner_info_list_one {
                li {
                    align-items: flex-start;
                    min-height: 80px;
                    width: 50%;
                    border-right: 1px solid #e1e1e1;
                    padding: 12px 20px;
                    margin: 0;

                    .el-textarea {
                        .el-textarea__inner {
                            border: none;
                        }
                    }
                }

                li:last-child {
                    border: none;
                }
            }
        }

        .owner_info_list:last-child {
            border: none;
        }
    }

    .owner_information_five {
        border: 1px solid #e1e1e1;

        >h3 {
            height: 40px;
            color: #333333;
            font-size: 16px;
            font-weight: bold;
            display: flex;
            align-items: center;
            background: #f2f4ff;
            padding-left: 17px;

            i {
                width: 6px;
                height: 16px;
                background: rgba(94, 117, 230, 1);
                border-radius: 3px;
                margin-right: 10px;
            }
        }

        .owner_info_list {
            padding: 12px 20px;
            color: #333333;
            font-size: 16px;
            border-bottom: 1px solid #e1e1e1;

            .owner_info_list_one {
                .message_wrap_pic {
                    .upload_img {
                        margin: 0 0 50px 0;
                        overflow-x: auto;

                        .upload_img_title {
                            font-size: 14px;
                            color: black;
                        }

                        .upload_img_type {
                            width: 710px;
                            margin-top: 8px;
                            display: flex;
                            align-items: top;

                            .upload_img_icon {
                                background: #f5f5f5;
                                border: 1px solid #ccc;
                                width: 150px;
                                min-width: 150px;
                                height: 100px;
                                border-radius: 4px;
                                display: flex;
                                flex-direction: column;
                                justify-content: center;
                                align-items: center;
                                color: #bbb;
                                margin-right: 20px;

                                img {
                                    width: 152px;
                                    height: 102px;
                                }

                                .icon-icon_shinei,
                                .icon-icon_huxing,
                                .icon-icon_VR,
                                .icon_baomi {
                                    font-size: 30px;
                                }

                                >span {
                                    margin-top: 5px;
                                    font-size: 14px;
                                }
                            }

                            .upload_img_text {
                                width: 150px;
                                min-width: 150px;
                                margin-left: 30px;
                                font-size: 14px;
                                line-height: 20px;
                                color: #bbb;
                            }
                        }
                    }
                }
            }
        }

        .owner_info_list:last-child {
            border: none;
        }
    }

    .footer_btn_wrap {
        margin-top: 20px;
        display: flex;
        justify-content: flex-end;

        .el-button {
            // width: 80px;
            height: 40px;
            background: #5e75e5;
            color: white;
            font-size: 16px;
            margin-left: 20px;

            &.remove_btn {
                background: #bbb;
            }

            &.save_btn {
                background: #22CA85;
            }
        }
    }
}</style>
